module.exports = __webpack_public_path__ + "img/class-delivery-banner-jp.15f8980.png";